/* eslint-disable no-console */
import * as React from 'react'
import MenuItem from '@mui/material/MenuItem'
import ListItemText from '@mui/material/ListItemText'
import ListSubheader from '@mui/material/ListSubheader'
import Select, { SelectChangeEvent, selectClasses } from '@mui/material/Select'
import _ from 'lodash'
import { useTranslation } from 'react-i18next'
import { Check } from '@mui/icons-material'
import { useConfirm } from '@components/Confirm'
import { Box } from '@mui/material'
import { CompanyItem } from '@services/common.services'
import useInit from '@utils/hooks/useInit'

export default function SelectCompany() {
  const { switchComp, initData } = useInit()
  const { t } = useTranslation()
  const [open, setOpen] = React.useState(false)
  const companies = _.get(initData, 'attributes.companies.data', [])
  // lodash find to      "company_type": "main"
  const current = _.find(
    companies,
    (companies) => companies.attributes.company_type === 'main'
  )?.attributes.company.data.attributes.uid

  const isSingleCompany = companies.length < 2

  //   const { id } = useParams()
  //   const navigate = useNavigate()

  const confirm = useConfirm()

  const handleChange = (event: SelectChangeEvent) => {
    // confirm before change
    const value = event.target.value
    if (value !== current) {
      //confirm dialog
      confirm({
        title: t('SYSCOMMON.switch_company'),
        description: t('SYSCOMMON.switch_company_desc'),
        confirmationText: t('SYSCOMMON.switch'),
      })
        .then(() => {
          switchComp({ company_uid: value })
            .unwrap()
            .then(() => {
              window.location.reload()
            })
            .catch(() => null)
        })
        .catch(() => {
          // eslint-disable-next-line no-console
          console.log('Cancel')
        })
    }
  }

  const handleClose = () => {
    setOpen(false)
  }

  return (
    <Box sx={{ pl: 1.5, pt: 2, display: isSingleCompany ? 'none' : 'block' }}>
      <Select
        labelId="company-select"
        id="company-simple-select"
        value={current}
        onChange={handleChange}
        displayEmpty
        inputProps={{ 'aria-label': 'Select company' }}
        fullWidth
        open={open}
        onOpen={() => setOpen(true)}
        onClose={() => setOpen(false)}
        sx={{
          maxHeight: 36,
          width: 215,
          '&.MuiList-root': {
            p: '8px',
          },
          [`& .${selectClasses.select}`]: {
            display: 'flex',
            alignItems: 'center',
            gap: '2px',
            pl: 1,
          },
        }}
      >
        <ListSubheader sx={{ pt: 0 }}>
          {t('SYSCOMMON.connected_companies')}
        </ListSubheader>
        {companies &&
          companies.map((p: CompanyItem) => {
            return (
              <MenuItem
                onClick={() => {
                  handleClose() // Close the select when clicking this item
                }}
                key={p.id}
                value={p.attributes.company.data.attributes.uid}
              >
                {p.attributes.company_type === 'main' ? (
                  <Check sx={{ fontSize: 10, mr: 1 }} />
                ) : (
                  <Box sx={{ width: 18 }}></Box>
                )}
                <ListItemText
                  primary={p.attributes.company.data.attributes.name}
                />
              </MenuItem>
            )
          })}
      </Select>
    </Box>
  )
}
